import { errorHandling } from "./";

const roundUpFilterEndpoint =
  "/tennis/Api/TournamentApi/GetResultsRoundUpFilters";
const roundUpEndpoint = "/tennis/Api/TournamentApi/GetResultsRoundUp";

interface getResultsRoundUpFiltersProps {
  startDate: string;
  endDate: string;
  tourCode: string | string[] | null | undefined;
}

export const getResultsRoundUpFilters = ({
  tourCode,
  startDate = "",
  endDate = ""
}: getResultsRoundUpFiltersProps) => {
  return fetch(
    `${process.env.HOST}${roundUpFilterEndpoint}?circuitCode=${tourCode}${
    startDate ? "&dateFrom=" + startDate : ""
    }${endDate ? "&dateTo=" + endDate : ""}`
  )
    .catch(errorHandling)
    .then(res => res.json());
};

interface getResultsRoundUpProps {
  startDate?: string;
  endDate?: string;
  tourCode?: string | string[] | null | undefined;
  take?: number;
  skip?: number | null;
  q?: string;
  zoneCode: string;
  nationCodes?: string;
  doorness?: string;
  surfaceCodes?: string;
  categories?: string;
  isOrderAscending?: boolean;
  orderField?: string;
  matchType?: string | null | number;
  ageCategories?: string | number;
  playerType?: string;
  grandSlams?: string;
  tennisCategories?: string;
}

export const getResultsRoundUp = ({
  q = "",
  take = 100,
  skip = 0,
  tourCode,
  startDate = "",
  endDate = "",
  zoneCode = "",
  nationCodes = "",
  doorness = "",
  surfaceCodes = "",
  categories = "",
  isOrderAscending,
  orderField = "",
  matchType = "",
  ageCategories = "",
  playerType = "",
  grandSlams = "",
  tennisCategories = ""
}: getResultsRoundUpProps) => {
  return fetch(
    `${process.env.HOST}${roundUpEndpoint}?take=${take
    }${tourCode ? "&circuitCode=" + tourCode : ""
    }${startDate ? "&dateFrom=" + startDate : ""
    }${endDate ? "&dateTo=" + endDate : ""
    }${skip !== null ? "&skip=" + skip : ""
    }${doorness ? "&indoorOutdoor=" + doorness : ""
    }${categories ? "&categories=" + categories : ""
    }${"&isOrderAscending=" + isOrderAscending
    }${orderField ? "&orderField=" + orderField : ""
    }${surfaceCodes ? "&surfaceCodes=" + surfaceCodes : ""
    }${q ? "&searchString=" + q : ""
    }${nationCodes ? "&nationCodes=" + nationCodes : ""
    }${zoneCode ? "&zoneCodes=" + zoneCode : ""
    }${matchType ? "&matchtype=" + matchType : ""
    }${ageCategories ? "&ageCategories=" + ageCategories : ""
    }${playerType ? "&playerTypes=" + playerType : ""
    }${grandSlams ? "&grandSlams=" + grandSlams : ""
    }${tennisCategories ? "&tennisCategories=" + tennisCategories : ""
    }`
  )
    .catch(errorHandling)
    .then(res => res.json());
};
